import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Button, Input, InputGroup, InputGroupAddon} from 'reactstrap';
import autobind from 'autobind-decorator';
import * as customers from 'customers/actions/customers';


@connect(
    state => {
        return {
            customers: state.customers
        }
    },
    dispatch => {
        return {
            setSearchText: searchText => dispatch(customers.setSearchText(searchText)),
            fetchCustomers: () => dispatch(customers.fetchCustomers())
        }
    }
)
export default class Search extends Component {

    @autobind
    setSearchText(e) {
        const searchText = e.target.value;
        this.props.setSearchText(searchText);
    }

    @autobind
    resetSearchText() {
        this.props.setSearchText('');
        this.props.fetchCustomers()
    }

    @autobind
    triggerSearch(e) {
        if (e.key === 'Enter') {
            this.props.fetchCustomers()
        }
    }

    render() {
        return (
            <InputGroup>
                <Input
                    placeholder="Suche"
                    type="text"
                    onChange={this.setSearchText}
                    onKeyPress={this.triggerSearch}
                    value={this.props.customers.searchText}
                />
                <InputGroupAddon addonType='append'>
                    <Button onClick={this.resetSearchText}>
                        Zurücksetzen
                    </Button>
                </InputGroupAddon>
            </InputGroup>

        )
    }

}